// Copyright 2026 The Lynx Authors. All rights reserved.
// Licensed under the Apache License Version 2.0 that can be found in the
// LICENSE file in the root directory of this source tree.

export const ELEMENT_TEMPLATE_PAGE_TYPE = 'page';
export const ELEMENT_TEMPLATE_PAGE_HANDLE_ID = 0;
export const ELEMENT_TEMPLATE_PAGE_ROOT_SLOT_INDEX = 0;
